import { render, staticRenderFns } from "./CustomerOutstandingPDCBarChart.vue?vue&type=template&id=f41c82ae"
import script from "./CustomerOutstandingPDCBarChart.vue?vue&type=script&lang=ts"
export * from "./CustomerOutstandingPDCBarChart.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports